<template>
    <v-menu transition="slide-y-transition"
            left
            bottom>
        <template v-slot:activator="{ on }">
            <v-btn class="card-menu__button flat-btn"
                   fab
                   small
                   v-on="on"
                   transition="scroll-y-transition"
                   color="transparent">
                <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        <v-list class="list__menu list__menu--lefty">
            <v-list-item class="list__menu-item">
                <v-list-item-title class="list__menu-text">
                    <v-icon>mdi-dots-horizontal</v-icon>
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-ripple @click="exportChart" class="list__menu-item">
                <v-list-item-title class="list__menu-text">
                    <v-img :src="require('@/assets/img/icons/export.svg')"></v-img>
                    <span>Export</span>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "TabCardMenu",
        methods: {
            exportChart: function () {
                console.log('exportChart')
            }
        }
    }
</script>

<style scoped>

</style>
